import { useEffect, useState } from "react";
import { makeReceiptOnLocal } from "../../apis/tryst/receipt-v2/should-receipt-be-made-on-local-util";
import UIForReceiptMadeonLocal from "./receipts-modal-new-UI-localMovement";
import ServerMadeReceiptsFlowUI from "./receipts-modal-old-UI";

export default function ReceiptAction() {
  const [isReceiptOnLocal, setIsReceiptOnLocal] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const check = () => {
      try {
        const result = makeReceiptOnLocal();
        if (!cancelled) {
          setIsReceiptOnLocal(result);
        }
      } catch {
        if (!cancelled) {
          setIsReceiptOnLocal(false);
        }
      }
    };

    check();

    return () => {
      cancelled = true;
      setIsReceiptOnLocal(false);
    };
  }, []);

  return isReceiptOnLocal ? (
    <UIForReceiptMadeonLocal />
  ) : (
    <ServerMadeReceiptsFlowUI />
  );
}
